import { useEffect, useState, useCallback } from 'react';

export interface ToastState {
  message: string;
  tone: 'success' | 'error';
}

/**
 * Minimal transient notification. Returns the element to render plus a
 * function to raise a message.
 */
export function useToast() {
  const [toast, setToast] = useState<ToastState | null>(null);

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => setToast(null), 4000);
    return () => clearTimeout(timer);
  }, [toast]);

  const show = useCallback((message: string, tone: ToastState['tone'] = 'success') => {
    setToast({ message, tone });
  }, []);

  const element = toast ? (
    <div className={`toast ${toast.tone === 'error' ? 'error' : ''}`} role="status" aria-live="polite">
      {toast.message}
    </div>
  ) : null;

  return { show, element };
}
